import { CommonModule } from "@angular/common";
import {NgModule} from "@angular/core";
import { FeatureFlagPipe } from "./feature-flag.pipe";

@NgModule({
    imports: [CommonModule],
    declarations: [FeatureFlagPipe],
    exports: [FeatureFlagPipe]

})
export class FeatureFlagPipeModule {}
